export const Currencies = {
  Sek: 1,
  Eur: 2,
};

export const autoReviewReasons = {
  Reject: "Reject",
  Approve: "Approve",
  Uncertain: "Uncertain",
};

export const invoiceStages = {
  UpComing: "Upcoming",
  ToBePaid: "To be paid",
  PartiallyPaid: "Partially paid",
  FullyPaid: "Fully paid",
  Late: "Late",
  Credited: "Credited",
};

export const invoiceRowTypes = {
  OtherFees: "Other fees",
  KFMFee: "KFM fee",
  CollectionFee: "Collection fee",
  InvoiceFee: "Admin fee",
  AdminFee: "Admin fee",
  PenaltyFee: "Penalty fee",
  ReminderFee: "ReminderFee",
  RescheduleFee: "Reschedule fee",
  RenewalFee: "Renewal fee",
  LateFee: "Late fee",
  Interest: "Interest",
  Principal: "Principal",
  IntermediationFee: "Intermedediation fee",
  PpiFee: "PPI fee",
  PostTerminationInterest: "Post-term interest",
};

export const applicationStages = {
  Draft: "Draft",
  Submitted: "Submitted",
  AwaitingOfferAcceptance: "Awaiting offer acceptance",
  AwaitingManualReview: "Awaiting manual review",
  FailedAutoReview: "Failed auto review",
  ManuallyApproved: "Manually approved",
  ManuallyRejected: "Manually rejected",
  AwaitingCompletion: "Awaiting completion",
  OnHold: "On hold",
};

export const applicationEmploymentStatuses = {
  Default: "Default",
  Permanent: "Permanent",
  Probationary: "Probationary",
  ProjectByHour: "Project by hour",
  SelfEmployed: "Self employed",
  ParentalSickLeave: "Parental sick leave",
  Retiree: "Retiree",
  Unemployed: "Unemployed",
  Student: "Student",
  Other: "Other",
  GivenNotice: "Given notice about probably getting fired",
  ShortTimeWorkAllowance: "Short time work allowance",
};

export const applicationLoanPurposes = {
  Default: "Default",
  LoanConsolidation: "Loan consolidation",
  DomesticPurchases: "Domestic purchases",
  Travel: "Travel",
  Vehicle: "Vehicle",
  Health: "Health",
  Business: "Business",
  RealEstate: "Real estate",
  FinancialProducts: "Financial products",
  Education: "Education",
  Other: "Other",
};

export const financingStages = {
  Financing: "Financing",
  Cancelled: "Cancelled",
  Abandoned: "Abandoned",
  Realised: "Realised",
  TargetReached: "Target reached",
  AcceptedEarly: "Accepted early",
};

export const financingRatings = {
  A: "A",
  B: "B",
  C: "C",
  D: "D",
  E: "E",
  F: "F",
  G: "G",
  H: "H",
  Unknown: "Unknown",
};

export const financingAssetTypes = {
  CCShortTerm: "CC short term",
  CCLongTerm: "CC long term",
  MarketPlace: "Marketplace lending",
  Factoring: "Factoring",
};

export const financingAssetClasses = {
  ConsumerCredit: "Consumer credit",
  Factoring: "Factoring",
  SMECredit: "SMECredit",
};

export const withdrawalReasonOptions = {
  GoalReached: "Goal reached",
  CapitalNeeded: "Capital needed",
  NotHappyWithReturn: "Not happy with return",
  NotHappyWithPlatform: "Not happy with platform",
};

export const willInvestorBeBackOptions = {
  Yes: "Yes",
  No: "No",
  DontKnow: `Don't know`,
};

export const transactionTypes = {
  IncomingDeposit: "Incoming Deposit",
  IncomingPayment: "Incoming Payment",
  PreliminaryTax: "Preliminary Tax",
  RescheduleFee: "Reschedule Fee",
  Credit: "Credit",
  Deposit: "Deposit",
  Withdrawal: "Withdrawal",
  Principal: "Principal",
  Interest: "Interest",
  ServiceFee: "Service Fee",
  TaxTransfer: "Tax Transfer",
  TaxPayment: "Tax Payment",
  Bonus: "Bonus",
  DebtSaleAmount: "Debt Sale Amount",
  DebtSaleCost: "Debt Sale Cost",
  Investment: "Investment",
  Reverse: "Reverse",
  ProvisionFundFee: "Provision Fund Fee",
  Lock: "Lock",
  Unlock: "Unlock",
  TradeCost: "Trade Cost",
  TradeAmount: "Trade Amount",
  IntermediationFee: "Intermediation Fee",
  InvoiceFee: "Admin Fee",
  AdminFee: "Admin Fee",
  LateFee: "Late Fee",
  ReminderFee: "Reminder Fee",
  PenaltyFee: "Penalty Fee",
  CollectionFee: "Collection Fee",
  KFMFee: "KFM Fee",
  RenewalFee: "Renewal Fee",
  WithdrawalFee: "Withdrawal Fee",
  OtherFee: "Other Fee",
};

export const transactionTypesKeysSorted = [
  "Bonus",
  "CollectionFee",
  "Credit",
  "DebtSaleAmount",
  "DebtSaleCost",
  "Deposit",
  "IncomingDeposit",
  "IncomingPayment",
  "Interest",
  "IntermediationFee",
  "Investment",
  "InvoiceFee",
  "AdminFee",
  "KFMFee",
  "LateFee",
  "Lock",
  "OtherFee",
  "PenaltyFee",
  "PreliminaryTax",
  "Principal",
  "ProvisionFundFee",
  "ReminderFee",
  "RenewalFee",
  "RescheduleFee",
  "Reverse",
  "ServiceFee",
  "TaxPayment",
  "TaxTransfer",
  "TradeAmount",
  "TradeCost",
  "Unlock",
  "Withdrawal",
  "WithdrawalFee",
];

export const loanStages = {
  Unknown: "Unknown",
  Performing: "Performing",
  Late: "Late",
  TerminationNoticed: "Termination Noticed",
  Terminated: "Terminated",
  CollectionProcess: "Collection Process",
  KFMProcess: "KFM Process",
  RescheduleProcess: "Reschedule Process",
  FullyPaid: "Fully Paid",
  Sold: "Sold",
  WrittenOff: "Written Off",
  Cancelled: "Cancelled",
};

export const loanStagesArray = [
  { type: "Unknown" },
  { type: "Performing" },
  { type: "Late" },
  { type: "TerminationNoticed" },
  { type: "Terminated" },
  { type: "CollectionProcess" },
  { type: "KFMProcess" },
  { type: "RescheduleProcess" },
  { type: "FullyPaid" },
  { type: "Sold" },
  { type: "WrittenOff" },
  { type: "Cancelled" },
];

export const countries = {
  SE: "Sverige",
  NO: "Norway",
  DK: "Denmark",
  FI: "Finland",
  AF: "Afghanistan",
  AX: "Ĺland Islands",
  AL: "Albania",
  DZ: "Algeria",
  AS: "American Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctica",
  AG: "Antigua and Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaijan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgium",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BA: "Bosnia and Herzegovina",
  BW: "Botswana",
  BV: "Bouvet Island",
  BR: "Brazil",
  IO: "British Indian Ocean Territory",
  BN: "Brunei Darussalam",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodia",
  CM: "Cameroon",
  CA: "Canada",
  CV: "Cape Verde",
  KY: "Cayman Islands",
  CF: "Central African Republic",
  TD: "Chad",
  CL: "Chile",
  CN: "China",
  CX: "Christmas Island",
  CC: "Cocos (Keeling) Islands",
  CO: "Colombia",
  KM: "Comoros",
  CG: "Congo",
  CD: "Congo, Democratic Republic",
  CK: "Cook Islands",
  CR: "Costa Rica",
  CI: "Cote D'Ivoire",
  HR: "Croatia",
  CU: "Cuba",
  CY: "Cyprus",
  CZ: "Czech Republic",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominican Republic",
  EC: "Ecuador",
  EG: "Egypt",
  SV: "El Salvador",
  GQ: "Equatorial Guinea",
  ER: "Eritrea",
  EE: "Estonia",
  ET: "Ethiopia",
  FK: "Falkland Islands (Malvinas)",
  FO: "Faroe Islands",
  FJ: "Fiji",
  FR: "France",
  GF: "French Guiana",
  PF: "French Polynesia",
  TF: "French Southern Territories",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Germany",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Greece",
  GL: "Greenland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard Island and Mcdonald Islands",
  VA: "Holy See (Vatican City State)",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hungary",
  IS: "Iceland",
  IN: "India",
  ID: "Indonesia",
  IR: "Iran",
  IQ: "Iraq",
  IE: "Ireland",
  IM: "Isle of Man",
  IL: "Israel",
  IT: "Italy",
  JM: "Jamaica",
  JP: "Japan",
  JE: "Jersey",
  JO: "Jordan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "Korea (North)",
  KR: "Korea (South)",
  XK: "Kosovo",
  KW: "Kuwait",
  KG: "Kyrgyzstan",
  LA: "Laos",
  LV: "Latvia",
  LB: "Lebanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libyan Arab Jamahiriya",
  LI: "Liechtenstein",
  LT: "Lithuania",
  LU: "Luxembourg",
  MO: "Macao",
  MK: "Macedonia",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshall Islands",
  MQ: "Martinique",
  MR: "Mauritania",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  FM: "Micronesia",
  MD: "Moldova",
  MC: "Monaco",
  MN: "Mongolia",
  MS: "Montserrat",
  MA: "Morocco",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Netherlands",
  AN: "Netherlands Antilles",
  NC: "New Caledonia",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk Island",
  MP: "Northern Mariana Islands",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Palestinian Territory, Occupied",
  PA: "Panama",
  PG: "Papua New Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippines",
  PN: "Pitcairn",
  PL: "Poland",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RE: "Reunion",
  RO: "Romania",
  RU: "Russian Federation",
  RW: "Rwanda",
  SH: "Saint Helena",
  KN: "Saint Kitts and Nevis",
  LC: "Saint Lucia",
  PM: "Saint Pierre and Miquelon",
  VC: "Saint Vincent and the Grenadines",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Sao Tome and Principe",
  SA: "Saudi Arabia",
  SN: "Senegal",
  RS: "Serbia",
  ME: "Montenegro",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapore",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Solomon Islands",
  SO: "Somalia",
  ZA: "South Africa",
  GS: "South Georgia and the South Sandwich Islands",
  ES: "Spain",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Suriname",
  SJ: "Svalbard and Jan Mayen",
  SZ: "Swaziland",
  CH: "Switzerland",
  SY: "Syrian Arab Republic",
  TW: "Taiwan",
  TJ: "Tajikistan",
  TZ: "Tanzania",
  TH: "Thailand",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad and Tobago",
  TN: "Tunisia",
  TR: "Turkey",
  TM: "Turkmenistan",
  TC: "Turks and Caicos Islands",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  AE: "United Arab Emirates",
  GB: "United Kingdom",
  US: "United States",
  UM: "United States Minor Outlying Islands",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Viet Nam",
  VG: "Virgin Islands, British",
  VI: "Virgin Islands, U.S.",
  WF: "Wallis and Futuna",
  EH: "Western Sahara",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
};

export const riskLevel = {
  Undefined: "Undefined",
  Minimal: "Minimal",
  Low: "Low",
  Moderate: "Moderate",
  High: "High",
  Extreme: "Extreme",
};

export const effectiveRiskLevel = {
  Low: "Low",
  Normal: "Normal",
  High: "High",
  Unacceptable: "Unacceptable",
};

export const investorDepotTransactionCategory = {
  Other: "Other",
  Withdrawal: "Withdrawal",
  Deposit: "Deposit",
};
